module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Strada_Sdrucciolevole_per_Ghiaccio-CL.ea042cda.svg";